import React from 'react'
import { Layout } from 'antd'

const Footer = () => (
  <Layout.Footer style={{ textAlign: 'center' }}>
    Copyright &copy; Bankrate {new Date().getFullYear()}
  </Layout.Footer>
)

export default Footer
